export const MESSAGE_STANDARD_INFO = 'Our agents can help you find a doctor, schedule appointments and answer your questions. ' +
    'Please keep in mind agents are unable to provide medical advice.';
export const MESSAGE_STANDARD_INFO_ESTIMATES = 'Our agents are happy to help with any questions related to estimates. ' +
    'Please keep in mind agents are unable to provide medical advice.';

export const MESSAGE_NO_AGENTS_AVAILABLE_DEFAULT = 'We\'re sorry, all of our agents are currently serving customers, ' +
    'please try again in a few minutes or call us at 800-727-4777.';
export const MESSAGE_NO_AGENTS_AVAILABLE_ESTIMATES = 'We\'re sorry, all of our agents are currently serving customers, ' +
    'please try again in a few minutes or call us at 858-927-7260.';

export const QUEUE_NAME_SCRIPPS_1_800 = 'Scripps - 1-800 Scripps';
export const QUEUE_NAME_SCRIPPS_ESTIMATES = 'Scripps - Estimates';
